module.exports = __webpack_public_path__ + "Flag-688.8f88ce27844feff6d0eb7ad8c30671e3.svg";